import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { IncidentCauseService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  IncidentCauseCreateDto,
  IncidentCauseDto,
  IncidentCauseExcelDownloadDto,
  IncidentCauseUpdateDto,
} from '../proxy/planning/dtos/incident-cause';
import { INCIDENTCAUSE_CONFIG, INCIDENTCAUSE_FIELDS } from './incident-cause.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-incident-cause',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, IncidentCauseService, ConfirmationService],
  templateUrl: './incident-cause.html',
  styleUrl: './incident-cause.scss',
})
export class IncidentCause extends BaseCrudComponent<
  IncidentCauseDto,
  IncidentCauseCreateDto,
  IncidentCauseUpdateDto,
  IncidentCauseExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(IncidentCauseService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('IncidentCause', ids),
  };
  config = INCIDENTCAUSE_CONFIG;
  fields = INCIDENTCAUSE_FIELDS;

  protected prepareUpdateDto(data: any, selected: IncidentCauseDto): IncidentCauseUpdateDto {
    return {
      incidentCategoryId: data.incidentCategoryId,
      incidentTypeId: data.incidentTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'IncidentCause';
  }
}
